import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
});

function RootComponent() {
  return <Outlet />;
}

function NotFoundComponent() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center">
        <p className="text-sm font-medium tracking-wide uppercase text-gold-700">404</p>
        <h1 className="mt-2 font-display text-4xl font-bold">Page not found</h1>
        <p className="mt-3 text-[color:var(--color-text-muted)]">
          The page you're looking for doesn't exist.
        </p>
        <a
          href="/"
          className="mt-6 inline-flex items-center rounded-md bg-ink-900 text-parchment-50 px-5 py-2.5 text-sm font-semibold"
        >
          Go home
        </a>
      </div>
    </div>
  );
}
